import React from 'react';
import { fmtINR, accentMap } from './reconUtils';

export function SumTile({ label, value, accent, testId, highlight }) {
  return (
    <div data-testid={testId} className={`relative rounded-2xl bg-white/75 backdrop-blur border ${highlight ? 'border-rose-200' : 'border-white/50'} p-3 overflow-hidden shadow-[0_8px_30px_rgba(15,23,42,0.04)]`}>
      <div className={`absolute -top-10 -right-10 w-24 h-24 rounded-full opacity-15 blur-2xl bg-gradient-to-br ${accentMap[accent]}`} />
      <p className="text-[10.5px] uppercase tracking-wider text-slate-500 font-medium">{label}</p>
      <p className="text-[17px] font-semibold tracking-tight text-slate-900 mt-0.5 leading-tight">{fmtINR(value)}</p>
    </div>
  );
}

export function BigMetric({ title, value, accent, subtitle, highlight, plain }) {
  return (
    <div className={`relative rounded-2xl bg-white/80 backdrop-blur border ${highlight ? 'border-rose-200 ring-2 ring-rose-100' : 'border-white/50'} p-6 overflow-hidden shadow-[0_8px_30px_rgba(15,23,42,0.04)]`}>
      <div className={`absolute -top-16 -right-16 w-44 h-44 rounded-full opacity-20 blur-3xl bg-gradient-to-br ${accentMap[accent]}`} />
      <p className="text-[11.5px] uppercase tracking-wider text-slate-500 font-medium">{title}</p>
      <p className="text-[32px] font-semibold tracking-tight text-slate-900 mt-1 leading-none">
        {plain ? value : fmtINR(value)}
      </p>
      {subtitle && <p className="text-[11.5px] text-slate-500 mt-2">{subtitle}</p>}
    </div>
  );
}
